import React, {useState, useEffect} from 'react';
import NovelCovid from 'novelcovid';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
//import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HomeIcon from '@material-ui/icons/Home';
import DnsRoundedIcon from '@material-ui/icons/DnsRounded';
import PublicIcon from '@material-ui/icons/Public';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';

import styles from '../../utils/navigationStyle';

import LinkTo from '../../utils/LinkTo';

import { useSelector, useDispatch } from 'react-redux';


import AllCountriesNavigation from './AllCountriesNavigation'; 
import StaticList from './StaticList';
//import SidebarNav from './SidebarNav';
import { getUserCountry } from '../../redux/actions/dataActions';

import { SET_COUNTRIES } from '../../redux/types';

const useStyles = makeStyles( theme =>({
    ...styles
})) 
const Navigator = (props) => {
  
  const { open, variant, handleSidebarClose, className, ...rest } = props;
  const classes = useStyles();
  const track = new NovelCovid();
  const [fetched, setFetched] = useState(false);
 // const [allCountries, setAllCountries] = useState([]);

  const dispatch = useDispatch();

 // const userCountry = useSelector(state => state.data.userCountry);
 // const allCountriesRedux = useSelector(state => state.data.countries);
 // let loading = useSelector(state => state.data.loading);

  useEffect(() => {
    if (fetched === false) {
     // dispatch(getUserCountry())
      getAllCountries();
    }
    
  }, [fetched]);


 const getAllCountries = async () => {

    try {
      const allCountries = await track.countries(null, { sort: 'cases' })
       //setAllCountries(allCountries);
       dispatch({type: SET_COUNTRIES, payload: allCountries})
       setFetched(true);
      } catch (err) {
      console.log(err);
    }
  };

  return (
    <SwipeableDrawer disableSwipeToOpen={true} minFlingVelocity={500} disableDiscovery={true} disableBackdropTransition={true} keepMounted={true} anchor="left" open={open} onClose={handleSidebarClose} variant={variant} {...rest}>
      <List disablePadding>

       <LinkTo handleSidebarClose={handleSidebarClose} to="/">
        <ListItem className={clsx(classes.firebase, classes.item, classes.itemCategory)}>
          Databode
        </ListItem>
        </LinkTo>
        
        
        <ListItem className={clsx(classes.item, classes.itemCategory)}>
          <ListItemIcon className={classes.itemIcon}>
             
          </ListItemIcon>
          <ListItemText
            classes={{
              primary: classes.itemPrimary,
            }}
          >
            
          </ListItemText>
        </ListItem>
        

          <React.Fragment>
            
            <ListItem className={classes.categoryHeader}>
              <ListItemText
                classes={{
                  primary: classes.categoryHeaderPrimary,
                }}
              >
                Countries Affected
              </ListItemText>
            </ListItem>
             
             <LinkTo handleSidebarClose={handleSidebarClose} to='/covid19/country' >
              <ListItem
                
                button
                className={clsx(classes.item, false && classes.itemActiveItem)}
              >
                <ListItemIcon className={classes.itemIcon}><PublicIcon /></ListItemIcon>
                <ListItemText
                  classes={{
                    primary: classes.itemPrimary,
                  }}
                >
                  All Countries
                </ListItemText>
              </ListItem>
              </LinkTo>

            {fetched && <AllCountriesNavigation handleSidebarClose={handleSidebarClose} className={classes.nav} />}

            <Divider className={classes.divider} />
          </React.Fragment>        

      
        
      </List>
    </SwipeableDrawer>
  );
}

Navigator.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default Navigator;

//, active && classes.itemActiveItem

//<StaticList /> 